export function generateFont(size, lineHeight) {
  return {
    fontSize: size,
    lineHeight: lineHeight,
  }
}